"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var react_1 = __importDefault(require("react"));
var atoms_1 = require("../../atoms");
var styles_1 = __importDefault(require("./styles"));
exports.AutocompleteSelect = react_1.default.memo(function (_a) {
    var onChange = _a.onChange, value = _a.value, ref = _a.ref, options = _a.options, AutocompleteProps = _a.AutocompleteProps, props = __rest(_a, ["onChange", "value", "ref", "options", "AutocompleteProps"]);
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(Autocomplete_1.default, __assign({}, AutocompleteProps, { id: props.id, value: value, options: options, fullWidth: true, onChange: function (_, newValue) {
            if (onChange)
                onChange(newValue);
        }, classes: { root: classes.autocomplete }, renderInput: function (params) { return (0, jsx_runtime_1.jsx)(atoms_1.TextField, __assign({}, props, params, { inputRef: ref, fullWidth: true })); } })));
});
